import React from 'react';
import ReactDOM from 'react-dom';
import './compiled/index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

import 'skeleton-css/css/normalize.css';
import 'skeleton-css/css/skeleton.css';

if (window.location.search === '?e=V2Vic2l0ZVVuYXZhaWxhYmxl' && window.innerWidth < 600 && window.innerHeight < 800) {
  // HACK - cache bug redirect (add the &1)
  window.location = 'https://gofullpage.com/connect?signin&1';
} else {
  ReactDOM.render(<App />, document.getElementById('root'));
  // registerServiceWorker();
}
